import {
  Checkbox,
  CheckboxGroup,
  Grid,
  GridItem,
  Textarea
} from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";
import { buildImgixUrl } from "@/lib";

import { QuestionContent } from "../question-content";
import { CheckboxQuestionProps } from "../types";

export const CheckboxQuestion = (props: CheckboxQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    contentLayoutProps,
    layoutProps,
    answer,
    checkboxAnswerLimit,
    size,
    minImageWidth = 300,
    isDisabled,
    handleChange,
    answerStackSpacing,
    options,
    showTextAnswer,
    otherAnswer,
    otherAnswerClassName,
    otherAnswerSize,
    otherAnswerProps,
    isHorizontal,
    handleOtherAnswer,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    questionId,
    layoutProps,
    questionLabel,
    questionLabelType,
    labelClassName,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent {...contentLayoutProps}>
        <CheckboxGroup
          onChange={handleChange}
          value={answer.map(String)}
          size={size}
        >
          <Grid
            templateColumns={{
              lg: `repeat(auto-fill, ${
                isHorizontal ? `${minImageWidth}px` : "1fr"
              })`
            }}
            alignItems="baseline"
            gap={answerStackSpacing}
          >
            {options &&
              options
                .filter((option) => !option.supportsTextAnswer)
                .map((option) => (
                  <GridItem
                    key={option.id}
                    sx={{
                      "@-moz-document url-prefix()": {
                        alignSelf: "normal"
                      }
                    }}
                  >
                    <Checkbox
                      id={option.id}
                      value={`${option.id}`}
                      imageSrc={buildImgixUrl(option.imageUrl)}
                      imageAlt={option.imageAltText || option.name}
                      imageMinW={minImageWidth}
                      isDisabled={
                        answer?.length === checkboxAnswerLimit &&
                        !(answer.indexOf(option.id) > -1)
                      }
                      minH={{ base: "44px", lg: "auto" }}
                      {...answerProps}
                    >
                      {option.name}
                    </Checkbox>
                  </GridItem>
                ))}
          </Grid>
          {options &&
            options
              .filter((option) => option.supportsTextAnswer)
              .map((option) => (
                <Checkbox
                  key={option.id}
                  mt={answerStackSpacing}
                  value={`${option.id}`}
                  imageSrc={buildImgixUrl(option.imageUrl)}
                  imageAlt={option.imageAltText || option.name}
                  isDisabled={
                    answer?.length === checkboxAnswerLimit &&
                    !(answer.indexOf(option.id) > -1)
                  }
                  {...answerProps}
                >
                  {option.name}
                </Checkbox>
              ))}
        </CheckboxGroup>
        {showTextAnswer && (
          <Grid templateColumns="repeat(12, 1fr)">
            <GridItem colSpan={{ base: 12, lg: 10, "2xl": 4 }}>
              <Textarea
                mt={2}
                isRequired
                aria-label={showTextAnswer.name}
                isDisabled={isDisabled}
                value={otherAnswer}
                onChange={handleOtherAnswer}
                className={otherAnswerClassName}
                size={otherAnswerSize}
                {...otherAnswerProps}
              />
            </GridItem>
          </Grid>
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
